/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AZServices = function () {
  function AZServices($) {
    var _this = this;
    _classCallCheck(this, AZServices);
    this.alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    this.headers = $('.item-list h3');
    this.searchBar = $('#a-z-search-bar');
    $('#reset-filters').click(function () {
      AZServices.clearFilters($);
      $('#reset-filters').toggleClass('active');
    });
    $('.back-to-top').click(function () {
      $('.back-to-top--button').trigger('click');
    });
    $('.hero__button-group .search').click(function () {
      _this.toggleSearchState($);
    });
    $('.hero__button-group .a-z-services').click(function () {
      _this.toggleServicesState($);
    });
    $('#close').click(function () {
      AZServices.clearFilters($);
      $('#services-search').val('');
    });
    $('.icon--search').click(function () {
      _this.toggleSearchState($);
    });
    $('.search-bar .content-wrapper .base-button').click(function () {
      var searchTerm = $('#services-search').val();
      AZServices.searchServices($, searchTerm);
    });
    $('#services-search').keydown(function (e) {
      var keyId = e.which || e.keyCode || 0;
      if (keyId === 13) {
        $('.search-bar .content-wrapper .base-button').trigger('click');
      }
    });
    this.createFilters($);
  }
  return _createClass(AZServices, [{
    key: "toggleSearchState",
    value: function toggleSearchState($) {
      AZServices.updateActiveTab($, '.search');
      this.searchBar.addClass('active');
    }
  }, {
    key: "toggleServicesState",
    value: function toggleServicesState($) {
      AZServices.clearFilters($);
      AZServices.updateActiveTab($, '.a-z-services');
      this.searchBar.removeClass('active');
      $('#reset-filters').addClass('active');
    }
  }, {
    key: "createFilters",
    value: function createFilters($) {
      var filterContainer = $('.a-z-services__alpha-filter');
      var headerIndex = 0;
      for (var i = 0; i < this.alphabet.length; i++) {
        var alphabetLetter = this.alphabet[i];
        if (headerIndex > this.headers.length - 1) {
          $(filterContainer).append(this.createFilterElement($, this.alphabet[i], 'disabled'));
        } else {
          var headerText = this.headers[headerIndex].innerText;
          if (this.alphabet.indexOf(headerText) === -1) {
            headerIndex += 1;
            headerText = this.headers[headerIndex].innerText;
          }
          if (alphabetLetter === headerText) {
            $(filterContainer).append(this.createFilterElement($, headerText, 'enabled'));
            headerIndex += 1;
          } else {
            $(filterContainer).append(this.createFilterElement($, alphabetLetter, 'disabled'));
          }
        }
      }
    }
  }, {
    key: "updateFilters",
    value: function updateFilters($, letter) {
      this.headers = $('.item-list h3');
      for (var i = 0; i < this.headers.length; i++) {
        if (this.headers[i].innerText !== letter) {
          $(this.headers[i]).parent().addClass('hidden');
        }
      }
    }
  }, {
    key: "createFilterElement",
    value: function createFilterElement($, letter, filterClass) {
      var _this2 = this;
      var element = $("<span class='filter-item ".concat(filterClass, "'>").concat(letter, "</span>"));
      $(element).click(function () {
        AZServices.clearFilters($);
        element.toggleClass('active');
        _this2.updateFilters($, letter);
      });
      return element;
    }
  }], [{
    key: "searchServices",
    value: function searchServices($, searchTerm) {
      if (searchTerm) {
        var sections = $('.item-list');
        sections.each(function (index, element) {
          var itemCount = 0;
          if (element.children.length && element.children[1].children.length) {
            for (var i = 0; i < element.children[1].children.length > 0; i++) {
              if (element.children[1].children[i].innerText.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
                itemCount += 1;
              } else {
                $(element.children[1].children[i]).addClass('hidden');
              }
            }
            if (itemCount < 1) {
              $(element).addClass('hidden');
            }
          }
        });
      } else {
        AZServices.clearFilters($);
      }
    }
  }, {
    key: "updateActiveTab",
    value: function updateActiveTab($, tab) {
      $('.hero__button-group > .active').removeClass('active');
      $(".hero__button-group ".concat(tab)).toggleClass('active');
    }
  }, {
    key: "clearFilters",
    value: function clearFilters($) {
      $('.item-list').removeClass('hidden');
      $('li').removeClass('hidden');
      $('.filter-item').removeClass('active');
      $('#reset-filters').removeClass('active');
    }
  }]);
}();
export { AZServices as default };
(function ($) {
  var isAZPage = document.getElementById('a-z-services');
  if (isAZPage) {
    var aZServices = new AZServices($);
  }
})(jQuery, Drupal);